import * as React from "react";
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
const programDescription = "Future Ready Australia Ltd delivers high-impact programs including Digital Literacy, AI & Coding Workshops, and Creative Learning Activities. We partner with schools and community groups to provide accessible, future-focused education that builds essential digital capabilities for the next generation.";
const serviceAreas = ["Sydney"];
const socialLinks = [];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265059" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight text-foreground">
              What We Do
            </h3>
            <p className="text-muted-foreground text-sm leading-relaxed font-default">
              {programDescription}
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight text-foreground">
              Our Communities
            </h3>
            <ul className="flex flex-col gap-3">
              {serviceAreas.map((area, i) => <li key={i} data-index={i}>
                  <Link to="/HomePage" className="text-muted-foreground hover:text-primary text-sm transition-colors inline-flex items-center gap-2 group font-default">
                    {area}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight text-foreground">
              Contact Us
            </h3>
            <ul className="flex flex-col gap-4">
              <li>
                <Link to="/HomePage" className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <MapPin className="size-5 shrink-0 mt-0.5 text-primary/60 group-hover:text-primary transition-colors" />
                  <span className="text-sm leading-tight font-default">
                    Sydney, NSW<br />
                    Australia
                  </span>
                </Link>
              </li>
              <li>
                <Link to="#contact-details" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Phone className="size-5 shrink-0 text-primary/60 group-hover:text-primary transition-colors" />
                  <span className="text-sm font-default">Enquire Online</span>
                </Link>
              </li>
              <li>
                <Link to="/HomePage" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Mail className="size-5 shrink-0 text-primary/60 group-hover:text-primary transition-colors" />
                  <span className="text-sm font-default">futurereadyaustralia@gmail.com</span>
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="my-8 bg-border" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-muted-foreground font-default">
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Link to="https://www.acnc.gov.au/charity/charities/fb991c9a-eb37-f111-88b5-00224812a1a7/profile" newTab className="hover:opacity-80 transition-opacity">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/ACNC-Registered-Charity-Logo_RGB.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/ACNC-Registered-Charity-Logo_RGB.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/ACNC-Registered-Charity-Logo_RGB.png-wvc-sizes" alt="ACNC Registered Charity Logo" className="h-20 aspect-square object-contain" loading="lazy" />
            </Link>
            <p className="text-center sm:text-left">
              &copy; {currentYear} Future Ready Australia Ltd. Made in Sydney.
            </p>
          </div>
          <div className="flex items-center gap-4">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}